export default __webpack_public_path__ + "static/media/spain.dec6ea19.svg";